import React from 'react'
import { Link } from 'react-router-dom'
import DestinationTable from './DestinationTable'

const DestinationList = () => {
  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
            <div className="col-sm-12">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <h3 className="fw-bold mb-0">Destination List</h3>
                    <div className="col-auto d-flex w-sm-100">
                        <Link to="/destination" className="btn btn-dark btn-set-task w-sm-100">Add Destination</Link>
                    </div>
                </div>
            </div>
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body">
                        <DestinationTable/>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default DestinationList